//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@nuxeo/nuxeo-elements/nuxeo-resource.js";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "SelectDoctypeStep",
  data() {
    return {
      search: null,
      searched: [],
      doctypes: [],
      selectedDocumentType: null,
      loading: true,
      show: false,
      nxql: null,
      schemaDefs: {},
      propertyDefs: {}
    };
  },

  computed: {
    ...mapGetters(["newModel"])
  },

  mounted() {
    this.runQuery();
    this.$refs.doctypes_pp.$.nxResource.$.nx.client
        .request("config/types")
        .get()
        .then(v => {
          this.schemaDefs = Object.entries(v.doctypes)
              .map(item => {
                return {type: item[0], schemas: item[1].schemas};
              })
              .reduce((map, obj) => {
                map[obj.type] = obj.schemas;
                return map;
              });

          this.propertyDefs = Object.entries(v.schemas)
              .map(item => {
                return {type: item[0], schemas: item[1]};
              })
              .reduce((map, obj) => {
                map[obj.type] = obj.schemas;
                return map;
              }, {});
        })
        .catch(e => this.displayError(e));
  },

  methods: {
    runQuery() {
      this.show = false;
      if (this.nxql) {
        this.$refs.doctypes_pp.params.queryParams = `AND ${this.nxql}`;
      } else {
        this.$refs.doctypes_pp.params.queryParams = " ";
      }
      this.$refs.doctypes_pp
          .fetch()
          .then(response => {
            this.doctypes = Object.keys(
                response.aggregations.doctypes_agg.buckets
            ).map((key, index) => {
              return {
                id: index,
                key: response.aggregations.doctypes_agg.buckets[key].key,
                docCount: response.aggregations.doctypes_agg.buckets[key].docCount
              };
            });

            this.searched = this.doctypes;
            this.loading = false;
          })
          .catch(err => {
            this.displayError(`Cannot fetch document types ${err}`);
            this.loading = false;
          });
    },

    ...mapMutations({
      displayError: "displayError",
      setNewModel: "setNewModel"
    }),

    select() {
      const tmpModel = Object.assign({}, this.newModel);
      tmpModel.selectedDocType = this.selectedDocumentType.key;
      tmpModel.docCount = this.selectedDocumentType.docCount;
      tmpModel.properties = this._computeProps(this.selectedDocumentType.key);
      this.setNewModel(tmpModel);
    },

    searchOnTable() {
      this.searched = this.searchByName(this.doctypes, this.search);
    },

    searchByName(items, term) {
      if (term) {
        return items.filter(item =>
            this.toLower(item.key).includes(this.toLower(term))
        );
      }
      return items;
    },

    toLower(term) {
      return term.toString().toLowerCase();
    },

    setNXQL() {
      const tmpModel = Object.assign({}, this.newModel);
      tmpModel.nxql = this.nxql;
      this.setNewModel(tmpModel);
    },

    dotClass(docCount) {
      switch (true) {
        case docCount < 200:
          return "red";
        case docCount >= 200 && docCount < 500:
          return "orange";
        case docCount >= 500:
          return "green";
        default:
          break;
      }
    },

    _computeProps(type) {
      const schemas = this.schemaDefs[type];
      schemas.map(schema => this.propertyDefs[schema]);

      return schemas
          .map(schema => {
            return {
              key: schema,
              props: this.propertyDefs[schema]
            };
          })
          .map(item => {
            const prefix =
                item.props["@prefix"] === "" ? item.key : item.props["@prefix"];
            const props = new Map(Object.entries(item.props));
            props.delete("@prefix");
            return {prefix: prefix, properties: props};
          })
          .map(obj => {
            const keys = Array.from(obj.properties.keys());
            return keys.map(key => obj.prefix + ":" + key);
          })
          .flatMap(v => v)
          .flatMap(v => {
            return {
              name: v,
              type: "undefined",
              count: 0
            };
          }, []);
    }
  }
};
